import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './index';
export interface NavItemData {
  eventKey: string;
  title: string;
  icon?: any;
  myIcon?: Record<string, any>;
  to?: string;
  target?: string;
  children?: NavItemData[];
  onClick?: any;
  isDefault?: boolean;
}
interface SidemenuData {
  accountId: number;
  menus: NavItemData[];
  expanded: boolean;
}
const initialState: SidemenuData = {
  accountId: -1,
  menus: [],
  expanded: true
};

const sidemenu = createSlice({
  name: 'sidemenu',
  initialState,
  reducers: {
    updateSidemenu: (state, { payload }) => {
      if (payload?.accountId > 0) {
        state.accountId = payload.accountId;
      }
      if (payload?.menus?.length) {
        state.menus = [...payload?.menus];
      }
    },
    updateExpanded: (state, { payload }) => {
      if (typeof payload === 'boolean') {
        state.expanded = payload;
      }
    }
  }
});

const { reducer, actions } = sidemenu;

export const { updateSidemenu, updateExpanded } = actions;
export const selectSidemenu = (state: RootState): any[] => state.sidemenu.menus;
export const isExpanded = (state: RootState): boolean =>
  state.sidemenu.expanded;
export const selectSidemenuId = (state: RootState): number =>
  state.sidemenu.accountId;

export default reducer;
